import apiTransfer from '@/api/vo/transferSerial';

const defaultState = () => ({
	responSuksesTransfer: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setSuksesTransfer(state, data) {
		state.responSuksesTransfer = data
	},
};

const actions = {

	transferMembership({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiTransfer.transferMembership(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesTransfer', data.results.data );
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, transaksi serial tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	transferProdukBinary({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiTransfer.transferProdukBinary(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesTransfer', data.results.data );
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, transaksi serial tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};